package com.crowpay.views.dialogs

import com.crowpay.*
import com.crowpay.views.components.nav.AppDimensions
import com.crowpay.sdk.notNullSession
import com.crowpay.utils.*
import com.crowpay.views.components.*
import com.crowpay.views.theming.*
import com.lightningkite.UUID
import com.lightningkite.kiteui.models.Align
import com.lightningkite.kiteui.models.px
import com.lightningkite.kiteui.models.rem
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.navigation.dialogScreenNavigator
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.lightningdb.MassModification
import com.lightningkite.lightningdb.condition
import com.lightningkite.lightningdb.inside
import com.lightningkite.lightningdb.modification

fun ViewWriter.checkboxSelectSpecification(selectedItems: SignalingList<Specification>, items: List<Specification>, isSet: Boolean): RowOrCol {
    val sharedState = shared {
        selectedItems().map { it.isSet }.firstOrNull()
    }

    return col {
        spacing = 0.px
        for (item in items) {
            val select = selectedItems.containsWritable(item)
            RemoveToggleSemantic.onNext - toggleButton {
                spacing = AppDimensions.buttonSpacing
                if (isSet) ::enabled {
                    val s = sharedState()
                    s == null || s == item.isSet
                }
                compact - row {
                    sizeConstraints(width = 1.5.rem, height = 1.5.rem) - centered - checkbox {
                        if (isSet) ::enabled {
                            val s = sharedState()
                            s == null || s == item.isSet
                        }
                        checked bind select
                    }
                    expanding - centered - body(item.title)
                    weight(0.8f) - centered - row {
                        weight(0.8f) - body {
                            content = item.price.renderDollars()
                            align = Align.Center
                        }
                    }
                }
                checked bind select
            }
        }
    }
}

class NewSpecViewDialog(
    options: List<Specification>,
    val isSet: Boolean,
    val withSelection: (suspend (String, Boolean, List<UUID>) -> Unit)? = null
) : Page {
    val options = options.filter { it.group == null }

    val selectedItems = SignalingList<Specification>()

    val groupTitle = Property("")
    val groupDescription = Property("")

    private val type = if (isSet) "Set" else "View"

    override fun ViewWriter.render2(): ViewModifiable {
        return dismissBackground {
            centered - dialog - stack {
                spacing = AppDimensions.fullIndent

                sizeConstraints(minWidth = 40.rem) - col {
                    spacing = AppDimensions.sectionIndent
                    title("New Spec $type")

                    requiredField("$type Title") {
                        textInput {
                            hint = "$type Title"
                            content bind groupTitle
                        }
                    }

                    field2("$type Description") {
                        sizeConstraints(height = 10.rem) - textArea {
                            content bind groupDescription
                        }
                    }

                    label2("Add Specifications") {
                        sizeConstraints(height = 17.rem) - scrolls - checkboxSelectSpecification(selectedItems, options, isSet)
                    }

                    row {
                        secondaryButton - button {
                            specCenteredText("Discard")
                            onClick("Discard Spec View") { dialogScreenNavigator.dismiss() }
                        }
                        primaryButton - button {
                            ::enabled { selectedItems().isNotEmpty() && groupTitle().isNotBlank() }

                            specCenteredText {
                                "Create ${groupTitle().ifBlank { "Spec $type" }}"
                            }

                            onClick("Create Spec $type") {
                                if (groupTitle.value.isBlank()) return@onClick

                                val session = notNullSession()

                                session.specifications.bulkModify(
                                    MassModification(
                                        condition<Specification> { spec -> spec._id inside selectedItems.map { it._id } },
                                        modification<Specification> {
                                            it.group assign SpecViewInfo(
                                                groupTitle.value,
                                                groupDescription.value,
                                                isSet
                                            )
                                        }
                                    )
                                )

                                withSelection?.invoke(groupTitle(), isSet, selectedItems.map { it._id })

                                dialogScreenNavigator.dismiss()
                            }
                        }
                    }
                }
            }
        }
    }
}